import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_ALL_SUBSCTIPTION_PACKAGE_REQUEST =
  'FETCH_ALL_SUBSCTIPTION_PACKAGE_REQUEST'
const FETCH_ALL_SUBSCTIPTION_PACKAGE_SUCCESS =
  'FETCH_ALL_SUBSCTIPTION_PACKAGE_SUCCESS'
const FETCH_ALL_SUBSCTIPTION_PACKAGE_FAILURE =
  'FETCH_ALL_SUBSCTIPTION_PACKAGE_FAILURE'

const CREATE_SUBSCTIPTION_PACKAGE_REQUEST =
  'CREATE_SUBSCTIPTION_PACKAGE_REQUEST'
const CREATE_SUBSCTIPTION_PACKAGE_SUCCESS =
  'CREATE_SUBSCTIPTION_PACKAGE_SUCCESS'
const CREATE_SUBSCTIPTION_PACKAGE_FAILURE =
  'CREATE_SUBSCTIPTION_PACKAGE_FAILURE'

const RENEW_SUBSCTIPTION_PACKAGE_REQUEST = 'RENEW_SUBSCTIPTION_PACKAGE_REQUEST'
const RENEW_SUBSCTIPTION_PACKAGE_SUCCESS = 'RENEW_SUBSCTIPTION_PACKAGE_SUCCESS'
const RENEW_SUBSCTIPTION_PACKAGE_FAILURE = 'RENEW_SUBSCTIPTION_PACKAGE_FAILURE'

const DELETE_SUBSCTIPTION_PACKAGE_REQUEST =
  'DELETE_SUBSCTIPTION_PACKAGE_REQUEST'
const DELETE_SUBSCTIPTION_PACKAGE_SUCCESS =
  'DELETE_SUBSCTIPTION_PACKAGE_SUCCESS'
const DELETE_SUBSCTIPTION_PACKAGE_FAILURE =
  'DELETE_SUBSCTIPTION_PACKAGE_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  subscriptionPackageList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_SUBSCTIPTION_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_SUBSCTIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        subscriptionPackageList: action.payload
      }
    case FETCH_ALL_SUBSCTIPTION_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_SUBSCTIPTION_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_SUBSCTIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_SUBSCTIPTION_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case RENEW_SUBSCTIPTION_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case RENEW_SUBSCTIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case RENEW_SUBSCTIPTION_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_SUBSCTIPTION_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_SUBSCTIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_SUBSCTIPTION_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export const getAllSubsctiptionPackageList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_SUBSCTIPTION_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await API.get(EndPoints.SUBSCRIPTION_PACKAGE + `/getAll`, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: FETCH_ALL_SUBSCTIPTION_PACKAGE_SUCCESS,
        payload: response.data
      })
    } catch (error) {
      dispatch({
        type: FETCH_ALL_SUBSCTIPTION_PACKAGE_FAILURE
      })
    }
  }
}

export const createSubscriptionPackage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_SUBSCTIPTION_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.SUBSCRIPTION_PACKAGE, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: CREATE_SUBSCTIPTION_PACKAGE_SUCCESS
      })
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_SUBSCTIPTION_PACKAGE_FAILURE
      })
    }
  }
}

export const renewSubscriptionPackage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: RENEW_SUBSCTIPTION_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.SUBSCRIPTION_PACKAGE + `/renew`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: RENEW_SUBSCTIPTION_PACKAGE_SUCCESS
      })
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      if (backendMessage === 'Subscription Package already renewed') {
        message.error('รายการนี้มีการต่ออายุแล้ว')
      } else {
        message.error(RESPONSE_MESSAGE.FAIL)
      }
      dispatch({
        type: RENEW_SUBSCTIPTION_PACKAGE_FAILURE
      })
    }
  }
}

export const deleteSubscriptionPackage = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_SUBSCTIPTION_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(`${EndPoints.SUBSCRIPTION_PACKAGE}/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: DELETE_SUBSCTIPTION_PACKAGE_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_SUBSCTIPTION_PACKAGE_FAILURE
      })
    }
  }
}
